import { MenuItem } from './menu.model';
import { environment } from '@env/environment';

export const MENU_ITEMS: MenuItem[] = [
  {
    name: 'Dashboard',
    route: '/dashboard',
    children: [],
    icon: 'icon-home-line',
    permissionNames: [
      'wallet_report_view_overview',
      'wallet_report_view_asset_overview',
      'pg_my_transaction_summary',
      'pg_my_last_five_transaction',
      'pg_my_transaction_dashboard_overview',
    ],
    type: 'page',
  },
  {
    name: 'My Assets',
    route: '/my-assets',
    children: [],
    icon: 'icon-wallet-03',
    permissionNames: ['wallet_report_view_asset_overview_list'],
    type: 'page',
  },
  {
    name: 'Operations',
    type: 'category',
    children: [
      {
        name: 'Settlement',
        route: '/operations/settlement',
        children: [],
        icon: '',
        permissionNames: ['pg_my_settlement_request'],
        type: 'page',
      },
      {
        name: 'Deposit',
        route: '/operations/deposit',
        children: [],
        icon: '',
        permissionNames: ['crypto_my_deposit_recent_transactions_view', 'crypto_my_deposit_address_generate'],
        type: 'page',
      },
      {
        name: 'Asset History',
        route: '/operations/asset-history',
        children: [],
        icon: '',
        permissionNames: ['pg_my_settlements', 'crypto_my_deposit_transactions_list_view'],
        type: 'page',
      },
    ],
    icon: 'icon-file-02',
  },
  {
    name: 'Payment Gateway',
    type: 'category',
    children: [
      {
        name: 'Transactions',
        route: '/payment-gateway/transactions',
        children: [],
        icon: '',
        permissionNames: ['pg_my_pay_out', 'pg_my_pays_in'],
        type: 'page',
      },
      {
        name: 'Webhook Log',
        route: '/payment-gateway/webhook-log-management',
        children: [],
        icon: '',
        permissionNames: ['my_pay_out_webhook_management_view', 'my_pay_in_webhook_management_view'],
        type: 'page',
      },
    ],
    icon: 'icon-credit-card-01',
  },
  {
    name: 'Settings',
    icon: 'icon-settings-01',
    type: 'category',
    children: [
      {
        name: 'Security',
        route: '/settings/security',
        children: [],
        icon: '',
        type: 'page',
      },
      {
        name: 'Account Settings',
        route: '/settings/account-settings',
        children: [],
        icon: '',
        type: 'page',
      },
      {
        name: 'Address Management',
        route: '/settings/address-management',
        permissionNames: ['pg_my_get_terminal_whitelist_addresses'],
        children: [],
        icon: '',
        type: 'page',
      },
      {
        name: 'Team Management',
        route: '/settings/team-management',
        permissionNames: ['idp_my_registration_List'],
        children: [],
        icon: '',
        type: 'page',
      },
    ],
  },

  {
    name: 'Documentation',
    icon: 'icon-code-02',
    type: 'category',
    children: [
      {
        name: `Introduction to ${environment.projectName == 'cg' ? 'CoiniGo' : 'CoiniJet'}`,
        icon: '',
        localFileAddress: 'introduction.pdf',
        children: [],
        type: 'page',
      },
      {
        name: 'API Documentation',
        icon: '',
        url: `${environment.ipgUrl}api/docs`,
        children: [],
        type: 'page',
      },
    ],
  },
];
